/**
 * Logs Vue and Nuxt errors to the console in non-production environments.
 * In production, errors are silently handled to avoid exposing internals.
 */
export default defineNuxtPlugin((nuxtApp) => {
  const config = useRuntimeConfig()

  if (config.siteEnv !== 'production') {
    // vue:error fires for component-level errors (render, lifecycle, watchers)
    nuxtApp.hook('vue:error', (err, target, info) => {
      console.log(err)
      console.log(target)
      console.log(info)
    })

    // app:error fires for fatal Nuxt-level errors (SSR, middleware, plugins)
    nuxtApp.hook('app:error', (err) => {
      console.log(err)
    })
  }
})
